// ** Initial user ability
export const organizerAbility = [
  {
    action: "chat",
    subject: "chat",
  },
  {
    action: "create",
    subject: "contactus",
  },
  {
    action: "read",
    subject: "notification",
  },
  {
    action: "create",
    subject: "tournament",
  },
  {
    action: "delete",
    subject: "tournament",
  },
  {
    action: "read",
    subject: "tournaments",
  },
  {
    action: "read",
    subject: "tournament",
  },
  {
    action: "fideverify",
    subject: "profile",
  },
  {
    action: "read",
    subject: "tournament_process",
  },
  {
    action: "update",
    subject: "confirm_players",
  },
  {
    action: "update",
    subject: "tournament",
  },
  {
    action: "read",
    subject: "wallet",
  },
  {
    action: "read",
    subject: "my_clubs",
  },
  {
    action: "read",
    subject: "club",
  },
  {
    action: "edit",
    subject: "tournament_prize",
  },
  {
    action: "delete",
    subject: "tournament_prize",
  },
  {
    action: "read",
    subject: "financial",
  },
  {
    action: "read",
    subject: "match_details",
  },
  {
    action: "read",
    subject: "tournament_details",
  },
];

export const managerAbility = [
  {
    action: "play",
    subject: "chess",
  },
  {
    action: "read",
    subject: "Auth",
  },
  {
    action: "play",
    subject: "match",
  },
  {
    action: "chat",
    subject: "chat",
  },
  {
    action: "create",
    subject: "contactus",
  },
  {
    action: "read",
    subject: "log",
  },
  {
    action: "read",
    subject: "notification",
  },
  {
    action: "create",
    subject: "tournament",
  },
  {
    action: "delete",
    subject: "tournament",
  },
  {
    action: "read",
    subject: "pairing",
  },
  {
    action: "read",
    subject: "tournaments",
  },
  {
    action: "read",
    subject: "tournament",
  },
  {
    action: "pair",
    subject: "tournament",
  },
  {
    action: "fideverify",
    subject: "profile",
  },
  {
    action: "read",
    subject: "requests",
  },
  {
    action: "read",
    subject: "tournament_process",
  },
  // {
  //   action: "update",
  //   subject: "confirm_players",
  // },
  {
    action: "read",
    subject: "users",
  },
  {
    action: "show",
    subject: "profile",
  },
  {
    action: "read",
    subject: "contactus",
  },
  {
    action: "update",
    subject: "tournament",
  },
  {
    action: "fake",
    subject: "result",
  },
  {
    action: "watch",
    subject: "match",
  },
  // {
  //   action: "read",
  //   subject: "wallet",
  // },
  {
    action: "charge",
    subject: "wallet",
  },
  {
    action: "change",
    subject: "user",
  },
  {
    action: "read",
    subject: "transactions",
  },
  {
    action: "edit",
    subject: "transaction",
  },
  {
    action: "read",
    subject: "withdraw",
  },
  {
    action: "read",
    subject: "cards",
  },
  {
    action: "create",
    subject: "representation",
  },
  {
    action: "read",
    subject: "financial",
  },
  {
    action: "read",
    subject: "my_clubs",
  },
  {
    action: "read",
    subject: "club",
  },
  {
    action: "change",
    subject: "club_status",
  },
  {
    action: "accept",
    subject: "tournament",
  },
  {
    action: "update",
    subject: "representation",
  },
  {
    action: "edit",
    subject: "tournament_arbiter",
  },
  {
    action: "set",
    subject: "match_result",
  },
  {
    action: "select",
    subject: "arbiter",
  },
  {
    action: "download",
    subject: "trf",
  },
  {
    action: "exclude",
    subject: "player",
  },
  {
    action: "edit",
    subject: "tournament_prize",
  },
  {
    action: "delete",
    subject: "tournament_prize",
  },
  {
    action: "read",
    subject: "location",
  },
  {
    action: "read",
    subject: "agent_link",
  },
  {
    action: "open",
    subject: "register",
  },
  {
    action: "delete",
    subject: "tournament_matches",
  },
  {
    action: "read",
    subject: "tournament_report",
  },
  {
    action: "accept",
    subject: "fide",
  },
  {
    action: "create",
    subject: "fake_round",
  },
  {
    action: "read",
    subject: "match_details",
  },
  {
    action: "read",
    subject: "tournament_details",
  },
];

export const initialAbility = [
  {
    action: "play",
    subject: "chess",
  },
  {
    action: "read",
    subject: "Auth",
  },
  {
    action: "play",
    subject: "match",
  },
  {
    action: "chat",
    subject: "chat",
  },
  {
    action: "create",
    subject: "contactus",
  },
  {
    action: "read",
    subject: "log",
  },
  {
    action: "read",
    subject: "notification",
  },
  {
    action: "create",
    subject: "tournament",
  },
  {
    action: "delete",
    subject: "tournament",
  },
  {
    action: "read",
    subject: "pairing",
  },
  {
    action: "read",
    subject: "tournaments",
  },
  {
    action: "read",
    subject: "tournament",
  },
  {
    action: "pair",
    subject: "tournament",
  },
  {
    action: "fideverify",
    subject: "profile",
  },
  {
    action: "read",
    subject: "requests",
  },
  {
    action: "read",
    subject: "tournament_process",
  },
  // {
  //   action: "update",
  //   subject: "confirm_players",
  // },
  {
    action: "read",
    subject: "users",
  },
  {
    action: "show",
    subject: "profile",
  },
  {
    action: "read",
    subject: "contactus",
  },
  {
    action: "update",
    subject: "tournament",
  },
  {
    action: "fake",
    subject: "result",
  },
  {
    action: "watch",
    subject: "match",
  },
  // {
  //   action: "read",
  //   subject: "wallet",
  // },
  {
    action: "charge",
    subject: "wallet",
  },
  {
    action: "change",
    subject: "user",
  },
  {
    action: "read",
    subject: "transactions",
  },
  {
    action: "edit",
    subject: "transaction",
  },
  {
    action: "read",
    subject: "withdraw",
  },
  {
    action: "read",
    subject: "cards",
  },
  {
    action: "create",
    subject: "representation",
  },
  {
    action: "read",
    subject: "financial",
  },
  {
    action: "read",
    subject: "my_clubs",
  },
  {
    action: "read",
    subject: "club",
  },
  {
    action: "change",
    subject: "club_status",
  },
  {
    action: "accept",
    subject: "tournament",
  },
  {
    action: "update",
    subject: "representation",
  },
  {
    action: "edit",
    subject: "tournament_arbiter",
  },
  {
    action: "set",
    subject: "match_result",
  },
  {
    action: "select",
    subject: "arbiter",
  },
  {
    action: "download",
    subject: "trf",
  },
  {
    action: "exclude",
    subject: "player",
  },
  {
    action: "edit",
    subject: "tournament_prize",
  },
  {
    action: "delete",
    subject: "tournament_prize",
  },
  {
    action: "read",
    subject: "location",
  },
  {
    action: "read",
    subject: "agent_link",
  },
  {
    action: "open",
    subject: "register",
  },
  {
    action: "delete",
    subject: "tournament_matches",
  },
  {
    action: "read",
    subject: "tournament_report",
  },
  {
    action: "accept",
    subject: "fide",
  },
  {
    action: "create",
    subject: "fake_round",
  },
  {
    action: "read",
    subject: "match_details",
  },
  {
    action: "read",
    subject: "tournament_details",
  },
];
export const chiefArbiterAbility = [
  {
    action: "read",
    subject: "Auth",
  },
  {
    action: "chief",
    subject: "match",
  },
  {
    action: "chat",
    subject: "chat",
  },
  {
    action: "create",
    subject: "contactus",
  },
  {
    action: "read",
    subject: "notification",
  },
  {
    action: "read",
    subject: "pairing",
  },
  {
    action: "read",
    subject: "tournaments",
  },
  {
    action: "read",
    subject: "tournament",
  },
  {
    action: "pair",
    subject: "tournament",
  },
  {
    action: "fideverify",
    subject: "profile",
  },
  {
    action: "read",
    subject: "requests",
  },
  {
    action: "read",
    subject: "tournament_process",
  },
  {
    action: "update",
    subject: "confirm_players",
  },
  {
    action: "show",
    subject: "profile",
  },
  // {
  //   action: "update",
  //   subject: "tournament",
  // },
  {
    action: "select",
    subject: "arbiter",
  },
  {
    action: "accept",
    subject: "tournament",
  },
  {
    action: "fake",
    subject: "result",
  },
  {
    action: "read",
    subject: "wallet",
  },
  {
    action: "add",
    subject: "tournament_player",
  },
  {
    action: "upload",
    subject: "arbiter_card",
  },
  {
    action: "arbiter",
    subject: "chess",
  },
  {
    action: "read",
    subject: "my_clubs",
  },
  {
    action: "read",
    subject: "club",
  },
  {
    action: "edit",
    subject: "tournament_arbiter",
  },
  {
    action: "set",
    subject: "match_result",
  },
  {
    action: "download",
    subject: "trf",
  },
  {
    action: "exclude",
    subject: "player",
  },
  {
    action: "read",
    subject: "agent_link",
  },
  {
    action: "delete",
    subject: "tournament_matches",
  },
  {
    action: "read",
    subject: "financial",
  },
  {
    action: "read",
    subject: "match_details",
  },
  {
    action: "read",
    subject: "tournament_details",
  },
];

export const arbiterAbility = [
  {
    action: "read",
    subject: "Auth",
  },
  {
    action: "arbiter",
    subject: "match",
  },
  {
    action: "play",
    subject: "match",
  },
  {
    action: "chat",
    subject: "chat",
  },
  {
    action: "create",
    subject: "contactus",
  },
  {
    action: "read",
    subject: "notification",
  },
  {
    action: "read",
    subject: "tournaments",
  },
  {
    action: "read",
    subject: "tournament",
  },
  {
    action: "fideverify",
    subject: "profile",
  },
  {
    action: "read",
    subject: "tournament_process",
  },
  {
    action: "update",
    subject: "confirm_players",
  },
  {
    action: "show",
    subject: "profile",
  },
  {
    action: "accept",
    subject: "tournament",
  },
  {
    action: "watch",
    subject: "match",
  },
  {
    action: "read",
    subject: "wallet",
  },
  {
    action: "upload",
    subject: "arbiter_card",
  },
  {
    action: "arbiter",
    subject: "chess",
  },
  {
    action: "read",
    subject: "my_clubs",
  },
  {
    action: "read",
    subject: "club",
  },
  {
    action: "read",
    subject: "agent_link",
  },
  {
    action: "read",
    subject: "financial",
  },
  {
    action: "read",
    subject: "match_details",
  },
  {
    action: "read",
    subject: "tournament_details",
  },
];

export const agentAbility = [
  {
    action: "create",
    subject: "representation",
  },
  {
    action: "presence",
    subject: "tournament_players",
  },
  {
    action: "accept",
    subject: "tournament",
  },
  {
    action: "read",
    subject: "tournaments",
  },
  {
    action: "create",
    subject: "contactus",
  },
  {
    action: "read",
    subject: "notification",
  },
  {
    action: "read",
    subject: "tournament",
  },
  {
    action: "fideverify",
    subject: "profile",
  },
  {
    action: "read",
    subject: "wallet",
  },
  {
    action: "read",
    subject: "my_clubs",
  },
  {
    action: "read",
    subject: "club",
  },
  {
    action: "update",
    subject: "representation",
  },
  {
    action: "create",
    subject: "agent_link",
  },
  {
    action: "read",
    subject: "agent_link",
  },
  {
    action: "read",
    subject: "financial",
  },
  {
    action: "read",
    subject: "match_details",
  },
  {
    action: "read",
    subject: "tournament_details",
  },
];

export const accountantAbility = [
  {
    action: "read",
    subject: "users",
  },
  {
    action: "read",
    subject: "notification",
  },
  {
    action: "charge",
    subject: "wallet",
  },
  {
    action: "read",
    subject: "transactions",
  },
  {
    action: "edit",
    subject: "transaction",
  },
  {
    action: "read",
    subject: "withdraw",
  },
  {
    action: "read",
    subject: "cards",
  },
  {
    action: "read",
    subject: "financial",
  },
  {
    action: "read",
    subject: "tournaments",
  },
  {
    action: "read",
    subject: "tournament_report",
  },
];

export const playerAbility = [
  {
    action: "read",
    subject: "tournaments",
  },
  {
    action: "read",
    subject: "tournament",
  },
  {
    action: "fideverify",
    subject: "profile",
  },
  {
    action: "play",
    subject: "chess",
  },
  {
    action: "read",
    subject: "wallet",
  },
  {
    action: "charge",
    subject: "wallet",
  },
  {
    action: "read",
    subject: "my_clubs",
  },
  {
    action: "read",
    subject: "club",
  },
  {
    action: "read",
    subject: "financial",
  },
  {
    action: "read",
    subject: "tournament_details",
  },
];

export default {
  Admin: initialAbility,
  Manager: managerAbility,
  Organizer: organizerAbility,
  Chief: chiefArbiterAbility,
  Arbiter: arbiterAbility,
  Agent: agentAbility,
  Accountant: accountantAbility,
  Player: playerAbility,
};

export const _ = undefined;
